"use client";

import { useEffect, useState } from "react";

const defaultItems = [
  { href: "#features", label: "功能介绍" },
  { href: "/posts", label: "实用教程" },
  { href: "#faq", label: "常见问题" },
];

type MobileNavItem = {
  href: string;
  label: string;
};

interface MobileNavProps {
  items?: MobileNavItem[];
  title?: string;
}

export default function MobileNav({ items = defaultItems, title = "导航" }: MobileNavProps) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) {
      return;
    }

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setOpen(false);
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [open]);

  return (
    <div className="sm:hidden">
      <button
        type="button"
        aria-label="打开菜单"
        aria-expanded={open}
        aria-controls="mobile-menu"
        className="rounded-md p-2 text-gray-600 hover:bg-green-50 hover:text-green-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
        onClick={() => setOpen((prev) => !prev)}
      >
        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>
      <div
        id="mobile-menu"
        aria-hidden={!open}
        className={`fixed inset-0 z-40 bg-white transition duration-200 ${
          open ? "opacity-100" : "pointer-events-none invisible opacity-0"
        }`}
      >
        <div className="flex items-center justify-between border-b border-green-100 px-4 py-4">
          <span className="text-lg font-semibold text-green-700">{title}</span>
          <button
            type="button"
            aria-label="关闭菜单"
            className="rounded-md p-2 text-gray-600 hover:bg-green-50 hover:text-green-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
            onClick={() => setOpen(false)}
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <nav className="px-4 py-6 space-y-3">
          {items.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="block rounded-xl border border-green-100 bg-green-50/60 px-4 py-3 text-base font-medium text-green-800 transition-colors hover:bg-green-100"
              onClick={() => setOpen(false)}
            >
              {item.label}
            </a>
          ))}
        </nav>
      </div>
    </div>
  );
}
